import { TABLE_ACTION, ACTION_SUBJECT, EVENT_TYPE, MODE } from '@atlaskit/editor-common/analytics';
export var getWidthInfoPayload = function getWidthInfoPayload(renderer) {
  var tablesInfo = [];
  var tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
  tableWrappers.forEach(function (tableWrapper) {
    var table = tableWrapper.querySelector(':scope > table');
    if (table) {
      var isNestedTable = Boolean(table.closest('td, th'));
      tablesInfo.push({
        tableWidth: table.scrollWidth,
        hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
        isNestedTable: isNestedTable
      });
    }
  });
  return {
    action: TABLE_ACTION.TABLE_WIDTH_INFO,
    actionSubject: ACTION_SUBJECT.TABLE,
    attributes: {
      editorWidth: renderer.scrollWidth,
      tableWidthInfo: tablesInfo,
      mode: MODE.RENDERER
    },
    eventType: EVENT_TYPE.OPERATIONAL
  };
};